import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { P2 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { HubLengthMessage } from '../../../styles/stylesStyled';
import { SupportTicket } from '../SupportTickets.types';
import {
  TicketsHeader,
  TicketsMobileStyled,
  TicketsStyled
} from '../SupportTicketsStyled';

interface TicketsType {
  tickets: SupportTicket[];
  setTicketId: any;
}

export const Tickets = ({ tickets, setTicketId }: TicketsType) => {
  const { t } = useTranslation('accounting');

  return (
    <AnimatedTab key={'InvoicesPage'}>
      <Desktop>
        <TicketsHeader>
          <div style={{ width: '15%' }}>Ticket ID</div>
          <div style={{ width: '35%' }}>Title</div>
          <div style={{ width: '25%' }}>Status</div>
          <div style={{ width: '25%' }}>Date Created</div>
        </TicketsHeader>
      </Desktop>

      {tickets?.length === 0 ? (
        <HubLengthMessage>No tickets to show</HubLengthMessage>
      ) : (
        tickets?.map((ticket: SupportTicket, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <TicketsStyled onClick={() => setTicketId(ticket.id)}>
                  <div style={{ width: '15%' }}>{ticket.id}</div>
                  <div style={{ width: '35%' }}>{ticket.title}</div>
                  <div style={{ width: '25%' }}>{ticket.status}</div>
                  <div style={{ width: '25%' }}>
                    {moment.utc(ticket?.dateCreated).format('DD/MM/YY')}
                  </div>
                </TicketsStyled>
              </Desktop>
              <Mobile>
                <TicketsMobileStyled onClick={() => setTicketId(ticket.id)}>
                  <Flexed between gap='30px' mb='10'>
                    <P2>{ticket.title}</P2>

                    <P2 caps>{ticket.status}</P2>
                  </Flexed>
                  <Flexed between gap='30px'>
                    <P2>#{ticket.id}</P2>

                    <P2>{moment.utc(ticket.dateCreated).format('DD/MM/YY')}</P2>
                  </Flexed>
                </TicketsMobileStyled>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
    </AnimatedTab>
  );
};
